import styled from 'styled-components';
import { colors } from '../colors';

interface modalPlanWrapperProps {
	paddingTop?: string;
	modalLG?: boolean;
	attachmentModal?: boolean;
	addUserModal?: boolean;
	modalMD?: boolean;
	addDocumentModal?: boolean;
	addDocumentSelectModal?: boolean;
}
const ModalPlanWrapper = styled.div<modalPlanWrapperProps>`
	transition: ease-in all 0.2s;
	box-sizing: border-box;
	max-width: 700px;
	background: ${colors.Grey100};
	display: flex;
	flex-direction: column;
	margin-top: 2%;
	margin-bottom: 2%;
	max-height: 94%;
	overflow: auto;
	border-radius: 2%;
	animation: fadein 0.5s;
	padding-top: ${({ paddingTop }) => paddingTop}!important;
	box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.2);
	@media screen and (max-width: 767px) {
		width: 96%;
	}
	@keyframes fadein {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	${({ modalLG }) =>
		modalLG &&
		`width:950px;
	`};
	${({ modalMD }) =>
		modalMD &&
		`width:527px;
	`};
	${({ attachmentModal }) =>
		attachmentModal &&
		`width:527px;
	`};
	${({ addUserModal }) =>
		addUserModal &&
		`width:430px;
	`}
	${({ addDocumentModal }) =>
		addDocumentModal &&
		`width:86%;
	`}
	${({ addDocumentSelectModal }) =>
		addDocumentSelectModal &&
		`width:60%;
    `}
`;

export default ModalPlanWrapper;
